<template>
    <v-menu offset-y :close-on-content-click="false" v-model="columnsMenu" content-class="bg-white">
        <template v-slot:activator="{ on, attrs }">
            <v-btn class="mx-2" icon v-bind="attrs" v-on="on">
                <v-icon color="white">mdi-cog-outline</v-icon>
            </v-btn>
        </template>
        <v-list flat>
            <v-subheader>Columns</v-subheader>
            <v-list-item-group
                    v-model="selectedFields"
                    multiple
            >
                <template v-for="header in customHeaders">
                    <v-list-item :value="header">
                        <template v-slot:default="{ active }">
                            <v-list-item-action class="mr-2">
                                <v-checkbox :input-value="active"></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{header}}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                    </v-list-item>
                </template>
            </v-list-item-group>
        </v-list>
        <v-spacer></v-spacer>
        <v-btn text color="secondary" @click="columnsMenu = false">Cancel</v-btn>
        <v-btn text color="primary" @click="updateFields">OK</v-btn>
    </v-menu>
</template>
<script>
    import store from "@/store";

    export default {
        props: {
            headers: {
                type: Array,
                default: ()=>[]
            },
            headerType: {
                type: String,
                default: ''
            },
        },
        data: ()=>({
            columnsMenu: false,
            selectedFields:[],
            customHeaders: [],
        }),

        async mounted () {
            this.customHeaders = [...this.headers].filter(header => header !== 'Actions');
            console.log(this.customHeaders);
            this.selectedFields = [...this.headers];
            try {
                const fields = localStorage.getItem(`${this.headerType}`);
                if (fields) {
                    this.selectedFields = JSON.parse(fields);
                }
            } catch (e) {
                console.log(e);
            }
        },

        methods: {
            updateFields(){
                this.selectedFields.push('Actions');
                localStorage.setItem(`${this.headerType}`, JSON.stringify(this.selectedFields));
                this.columnsMenu = false;
                store.dispatch('affiliates/updateColumnsList', true);
            }
        },

    }
</script>